module.exports = __webpack_public_path__ + "img/logo.b8c8819.svg";